module.exports = __webpack_public_path__ + "static/media/bouncer_rocker 6-12 - 100px.0746a9ea.png";